// Fonction pour formater une date au format JJ/MM/AAAA
export function formatDateForDisplay(date) {
  // Retourne uniquement le jour au format numérique
  return `${date.getDate()}`;
}

// Fonction pour formater une date pour l'input date (YYYY-MM-DD)
export function formatDateForInput(date) {
  return date.toISOString().split('T')[0];
}

// Fonction pour parser une chaîne de date au format JJ/MM/AAAA
export function parseDateString(dateString) {
  try {
    // Nettoyer la chaîne
    dateString = dateString.trim();

    // Si vide, retourner la date du jour
    if (!dateString) {
      return new Date();
    }

    // Extraire les composants (jours/mois/année)
    const parts = dateString.match(/(\d+)[\/\.\-](\d+)[\/\.\-](\d+)/);

    if (parts.length !== 4) {
      console.error("Nombre incorrect de parties dans la date:", parts);
      throw new Error("Format de date incorrect");
    }

    const day = parseInt(parts[1], 10);
    const month = parseInt(parts[2], 10) - 1; // Mois commence à 0 en JavaScript
    let year = parseInt(parts[3], 10);

    // Si l'année est à 2 chiffres, supposer qu'il s'agit des années 2000+
    if (year < 100) year += 2000;

    const date = new Date(year, month, day, 12, 0, 0);

    // Vérifier si la date est valide
    if (isNaN(date.getTime())) {
      console.error("Date invalide après construction");
      throw new Error("Date invalide");
    }

    return date;

  } catch (error) {
    console.error("Erreur lors du parsing:", error);
    throw new Error("Format de date invalide. Utilisez le format JJ/MM/AAAA");
  }
}

// Fonction pour obtenir une date de tri précise
export function getElementDate(type, date, isEndSeparator = false) {
  const actualDate = new Date(date);
  switch(type) {
    case 'year':
      actualDate.setHours(0, 0, 0, 0);
      return actualDate;
    case 'month':
      actualDate.setHours(0, 0, 1, 0);
      return actualDate;
    case 'today-separator':
      // IMPORTANT : Le séparateur "aujourd'hui" entre les mois et les autres séparateurs
      actualDate.setHours(0, 0, 1, 500);
      return actualDate;
    case 'separator':
      if (isEndSeparator) {
        actualDate.setHours(23, 59, 59, 999);
      } else {
        actualDate.setHours(0, 0, 2, 0);
      }
      return actualDate;
    case 'event':
      actualDate.setHours(12, 0, 0, 0);
      return actualDate;
    default:
      return actualDate;
  }
}

// Fonction pour grouper les événements par année puis par mois
export function groupEventsByYearAndMonth(events) {
  const groups = {};

  events.forEach(event => {
    const date = new Date(event.startDate);
    const year = date.getFullYear().toString();
    // Les mois sont de 0 à 11, mais on veut les afficher de 01 à 12
    const month = (date.getMonth() + 1).toString().padStart(2, '0');

    // Initialiser l'année si elle n'existe pas
    if (!groups[year]) {
      groups[year] = {};
    }

    // Initialiser le mois si il n'existe pas
    if (!groups[year][month]) {
      groups[year][month] = [];
    }

    groups[year][month].push(event);
  });

  return groups;
}